import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a66d2ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4a66d2ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a66d2ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a66d2ce')) {
      api.createRecord('4a66d2ce', component.options)
    } else {
      api.reload('4a66d2ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a66d2ce&scoped=true", function () {
      api.rerender('4a66d2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Dashboard/index.vue"
export default component.exports